import angular from 'angular';
import DocumentService from '@/shared/services/DocumentService';
import { isWord, isPdf } from '@/shared/utils/mime';
import { mapSuggestedMailAddressAngularFilter } from '@/shared/services/ObjectDisplayService';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';

angular
  .module('cxTaskflow')
  .controller('MailDocumentDialogCtrl', [
    '$scope',
    '$element',
    '$timeout',
    '$translate',
    '$q',
    '$filter',
    'dataCache',
    'templateHttpSvc',
    'resourceFactorySvc',
    'flySvc',
    '$http',
    'appUrls',
    'dialogsSvc',
    'close',
    'document',
    'asPdf',
    'relationId',
    'companyId',
    mailDocumentDialogCtrl,
  ]);

function mailDocumentDialogCtrl(
  $scope,
  $element,
  $timeout,
  $translate,
  $q,
  $filter,
  dataCache,
  templateHttpSvc,
  resourceFactorySvc,
  flySvc,
  $http,
  appUrls,
  dialogsSvc,
  close,
  document,
  asPdf,
  relationId,
  companyId,
) {
  var vm = this;
  vm.templates = [];
  vm.sending = false;
  vm.email = {};
  vm.showValidation = false;
  vm.addresses = [];
  vm.addressLabels = {};
  vm.sendTo = [];
  vm.cc = [];
  vm.bcc = [];
  vm.employeeLabels = {};
  vm.employeeAddresses = [];
  vm.empTo = [];
  vm.empCc = [];
  vm.empBcc = [];
  vm.attachments = [];
  vm.loadingAttachments = false;
  vm.loadingTemplate = true;
  vm.document = {
    ...document,
    signingStatus: document.signingStatus === 2 ? 10 : document.signingStatus, // if current status is required, we'll set it to pending
  };

  vm.signingStatus = [2, 10, 20];

  var initializeAttachments = () => {
    const { mime, id: documentId, name } = document;
    if (asPdf) {
      // no conversion needed if there was a document uploaded and it's a pdf
      if (isPdf(mime)) {
        vm.attachments = [
          {
            documentId,
            name,
            mime,
          },
        ];
      } else {
        // conversion needed, convert the document (Word) to pdf and save it to our doc-ms so it can be emailed
        vm.loadingAttachments = true;
        DocumentService.convertAndSaveToPdf(documentId).then(
          result => {
            $timeout(function() {
              vm.loadingAttachments = false;
              vm.attachments.push({
                documentId: result.id,
                name: result.name,
                mime: result.mime,
                documentType: result.documentType,
              });
              vm.document = {
                ...document,
                signingStatus: vm.document.signingStatus,
                name: result.name,
                mime: result.mime,
                documentType: result.documentType,
              };
            }, 0);
          },
          error => {
            vm.loadingAttachments = false;
            flySvc.error(error);
            console.error(error);
          },
        );
      }
    } else {
      // attachment is the original document
      vm.attachments = [
        {
          documentId,
          name,
          mime,
        },
      ];
    }
  };
  initializeAttachments();

  var showError = function(error) {
    vm.sending = false;
    flySvc.error(error);
  };

  templateHttpSvc.getTemplates(13).then(function(data) {
    vm.templates = data.map(item => {
      item.label = $filter('translateList')(item.id, 'template', item.name);
      return item;
    });
    if (vm.templates.length === 1) vm.template = vm.templates[0];
    vm.refreshPreview();
  });

  $q.all({
    addresses: resourceFactorySvc.get('address').mailSuggestions({
      id: relationId,
    }).$promise,
    commSetting: resourceFactorySvc.get('commSetting').query({
      id: relationId,
    }).$promise,
  }).then(function({ addresses, commSetting }) {
    vm.addressLabels = addresses.reduce((o, x) => {
      if (!x || !x.emailAddress) return o;
      if (o[x.emailAddress.toLowerCase()]) return o;
      const label = mapSuggestedMailAddressAngularFilter(x, $filter);
      if (!label) return o;
      o[x.emailAddress.toLowerCase()] = label;
      return o;
    }, {});
    vm.addresses = addresses.reduce((a, x) => {
      if (!x) return a;
      if (a.some(y => y.toLowerCase() === x.emailAddress.toLowerCase())) return a;
      a.push(x.emailAddress);
      return a;
    }, []);
    var main = addresses.find(a => !!a.emailAddress && a.isMain && a.linkType === null);
    if (vm.addresses.length) {
      vm.sendTo = commSetting.reduce(function(a, e) {
        if (e.purpose === 0 && e.medium === 1 && e.type === 0) {
          var address = addresses.find(function(addr) {
            return !!addr.emailAddress && addr.addressId === e.addressId;
          });
          if (address) a.push(address.emailAddress);
        }
        return a;
      }, []);
      vm.cc = commSetting.reduce(function(a, e) {
        if (e.purpose === 0 && e.medium === 1 && e.type === 1) {
          var address = addresses.find(function(addr) {
            return !!addr.emailAddress && addr.addressId === e.addressId;
          });
          if (address) a.push(address.emailAddress);
        }
        return a;
      }, []);
      vm.bcc = commSetting.reduce(function(a, e) {
        if (e.purpose === 0 && e.medium === 1 && e.type === 2) {
          var address = addresses.find(function(addr) {
            return !!addr.emailAddress && addr.addressId === e.addressId;
          });
          if (address) a.push(address.emailAddress);
        }
        return a;
      }, []);

      if (!vm.sendTo.length) {
        //No comm settings, add main or first or empty
        vm.sendTo.push((main && main.emailAddress) || vm.addresses[0] || '');
      }
    } else {
      //No addresses, add empty input
      vm.sendTo.push('');
    }
  }, showError);

  resourceFactorySvc.get('relation').employees(
    { id: relationId },
    employees => {
      const users = dataCache
        .getArray('user')
        .filter(x => x.isActive || !x.hidden)
        .map(x => {
          let label = `${x.firstName} ${x.lastName} (${x.email})`;
          const relationEmployees = employees
            .filter(e => e.userId === x.userID)
            .map(e => $filter('translateList')(e.profile, 'employeeprofile'))
            .sort();
          if (relationEmployees.length === 0) return { ...x, label, isRelationEmployee: false };

          return {
            ...x,
            label: `${label} (${relationEmployees.join(', ')})`,
            isRelationEmployee: true,
          };
        })
        .sort(dynamicSortMultiple('-isRelationEmployee', 'firstName', 'lastName', 'email'));
      vm.employeeAddresses = users.map(x => x.email);
      vm.employeeLabels = users.reduce((o, x) => {
        if (!x || !x.email) return o;
        o[x.email.toLowerCase()] = x.label;
        return o;
      }, {});
    },
    showError,
  );
  vm.getAddressLabel = address => {
    if (!address) return address;
    if (typeof address !== 'string') {
      console.log(address);
      return address;
    }
    return vm.addressLabels[address.toLowerCase()] || address;
  };
  vm.getEmpAddressLabel = address => {
    if (!address) return address;
    if (typeof address !== 'string') {
      console.log(address);
      return address;
    }
    return vm.employeeLabels[address.toLowerCase()] || address;
  };
  vm.refreshPreview = function() {
    vm.preview = null;
    vm.previewError = null;
    vm.loadingTemplate = true;
    if (!vm.template) {
      vm.preview = {
        body: null,
        subject: null,
      };
      vm.loadingTemplate = false;

      return;
    }
    $http
      .post(appUrls.api + '/api/template/GetRelationMail', {
        templateId: vm.template && vm.template.id,
        relationId: relationId,
      })
      .then(function(response) {
        var result = response.data;
        if (result) {
          vm.preview = result;
          if (vm.preview.body === null && vm.preview.subject === null) {
            flySvc.message('msgTemplateNotInLanguage');
          }
          if (
            vm.preview.recipients &&
            vm.preview.recipients.length &&
            (!vm.sendTo.length || !vm.sendTo[0])
          ) {
            vm.sendTo = vm.preview.recipients;
          }
          if (vm.preview.templateLanguageId) {
            $http
              .get(
                appUrls.documents + '/api/documents/links/' + vm.preview.templateLanguageId + '/4',
              )
              .then(function(response) {
                var result = response.data;
                if (result && result.length > 0) {
                  if (!vm.attachments) vm.attachments = [];
                  result.forEach(function(attachment) {
                    vm.attachments.push(attachment);
                  });
                }
              })
              .catch(function(error) {
                showError(error);
              });
          }

          vm.loadingTemplate = false;
        }
      })
      .catch(function(error) {
        console.error(error);
        vm.previewError = flySvc.getErrorMsg(error);
        flySvc.error(error);
        vm.loadingTemplate = false;
      });
  };

  vm.uploadAttachment = function(files) {
    if (!files || files.length < 1) return;

    var formData = new FormData();
    formData.append('relationId', relationId);

    files.forEach(function(file) {
      formData.append('data', file.data);
    });

    $http({
      method: 'POST',
      url: appUrls.documents + '/api/documents?documentType=15',
      headers: {
        'Content-Type': undefined,
      },
      data: formData,
    })
      .then(function(response) {
        var result = response.data;
        if (result && result.length > 0) {
          result.forEach(function(file) {
            vm.attachments.push(file);
          });
        }
      })
      .catch(function(error) {
        flySvc.error(error);
        return '';
      });
  };
  vm.addEmailAndSelect = function(list, cssSelector) {
    list.push('');
    $timeout(function() {
      $element
        .find(`.form-group .row.${cssSelector} .dropdown input[type="text"]`)
        .filter(':visible')
        .last()
        .focus();
    }, 200);
  };
  vm.addAddress = function(type) {
    switch (type) {
      case 0:
        return vm.addEmailAndSelect(vm.sendTo, 'email');

      case 1:
        return vm.addEmailAndSelect(vm.cc, 'cc');

      case 2:
        return vm.addEmailAndSelect(vm.bcc, 'bcc');
      case 10:
        return vm.addEmailAndSelect(vm.empTo, 'emp-to');

      case 11:
        return vm.addEmailAndSelect(vm.empCc, 'emp-cc');

      case 12:
        return vm.addEmailAndSelect(vm.empBcc, 'emp-bcc');
    }
  };

  vm.validateEmail = function(value, emptyValid) {
    if (!value && emptyValid) return true;
    return /^[^@]+@.+\..+$/.test(value);
  };

  vm.validate = function() {
    if (!vm.preview || !vm.preview.subject || !vm.preview.body) return false;
    if (vm.sendTo.length + vm.empTo.length === 0) return false;

    for (var j = 0; j < vm.sendTo.length; j++) {
      if (!vm.validateEmail(vm.sendTo[j], false)) {
        flySvc.error('msgInvalidEmailAddress');
        return false;
      }
    }
    for (var j = 0; j < vm.cc.length; j++) {
      if (!vm.validateEmail(vm.cc[j], false)) {
        flySvc.error('msgInvalidEmailAddress');
        return false;
      }
    }
    for (var j = 0; j < vm.bcc.length; j++) {
      if (!vm.validateEmail(vm.bcc[j], false)) {
        flySvc.error('msgInvalidEmailAddress');
        return false;
      }
    }
    return true;
  };

  vm.save = function() {
    if ($scope.form.$invalid || vm.sending) return;
    if (!vm.validate()) return;
    vm.sending = true;
    vm.preview.to = [...vm.sendTo, ...vm.empTo].filter(x => !!x);
    vm.preview.cc = [...vm.cc, ...vm.empCc].filter(x => !!x);
    vm.preview.bcc = [...vm.bcc, ...vm.empBcc].filter(x => !!x);
    vm.preview.emailId = vm.email.id;
    vm.preview.relationId = relationId;
    vm.preview.linkId = relationId;
    vm.preview.emailLinkType = 4; // relation
    vm.preview.companyId = companyId;
    vm.preview.emailTemplateId = vm.template && vm.template.id;
    if (vm.attachments && vm.attachments.length) {
      vm.preview.attachmentDocumentIds = vm.attachments.map(x => x.documentId || x.id);
    }

    vm.preview.attachmentSigningStatusUpdates = [
      { documentId: vm.document.id, signingStatus: vm.document.signingStatus },
    ];

    $http
      .post(appUrls.documents + '/api/emails/CreateAndSend', vm.preview)
      .then(function() {
        vm.sending = false;
        flySvc.success('EmailSent');
        $element.modal('hide');
        const updatedDocument = {
          ...document,
          signingStatus: vm.document.signingStatus,
        };
        close(updatedDocument, 500);
      }, showError)
      .error(showError);
  };

  vm.deleteAttachment = function(attachment) {
    dialogsSvc.showYesNo('comfirmDeleteTitle', 'confirmDeleteEmailAttachment').then(function() {
      // the attachment is a new document that was uploaded in the email modal. Delete the corresponding document
      const documentId = attachment.documentId || attachment.id;
      if (attachment.documentType === 15) {
        $http
          .delete(appUrls.documents + '/api/documents/' + documentId)
          .then(function(response) {
            var result = response.data;
            var index = vm.attachments.indexOf(attachment);
            vm.attachments.splice(index, 1);
          })
          .catch(function(error) {
            flySvc.error(error);
            return '';
          });
      } else {
        // the attachment is an existing document, presumably an email attachment. Dont delete the document from the doc-store
        var index = vm.attachments.indexOf(attachment);
        vm.attachments.splice(index, 1);
      }
    });
  };
  vm.cancel = function() {
    close(false, 500);
  };

  vm.downloadAttachment = attachment =>
    DocumentService.download(attachment.documentId || attachment.id);
}
